
/* injects from baggage-loader */

angular.module("siter.io").controller("EditLessonTemplateController", [
  "$scope", "$rootScope", "$modalInstance", "Lesson", "Translit", "FileUploader", "Restangular", "$state", "$cookies", "template", "$http", "mainTemplate",
  ($scope, $rootScope, $modalInstance, Lesson, Translit, FileUploader, Restangular, $state, $cookies, template, $http, mainTemplate) => {

    $scope.landing = {};
    $scope.site = template;
    $scope.mainTemplate = mainTemplate;
    $scope.site.tags = _.map($scope.site.tags.split(","), (tag, index) => {
      return { text: tag, id: index };
    });
    $scope.site.colors = _.map($scope.site.colors, (tag, index) => {
      return { text: tag, id: index };
    });

    $scope.transliterate = (text, entorus) => {
      if (entorus === null) {
        entorus = false;
      }
      Translit.one(text, entorus);
    };

    $scope.transliterate_3 = (text, entorus) => {
      if (entorus === null) {
        entorus = false;
      }
      Translit.three(text, entorus);
    };

    Restangular.all('/lms_page_templates/tags').getList().then((items) => {
      $scope.items = _.map(items, (item, index) => {
        return {
          text: item,
          id: index
        };
      });
    });

    $scope.loadTags = (query) => {
      return Restangular.all("/lms_page_templates/tags?q=" + query).getList();
    };

    $scope.clone = () => {
      $scope.cloning = true;
      Lesson.clone(template.id).then((data) => {
        $scope.cloning = false;
        $scope.close();
        $rootScope.$broadcast("lesson_form:created", data, template);
      });
    };

    $scope.webPreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/lms_pages/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.webPreviewUploader.onAfterAddingFile = (item) => {
      const ref = item.file.type;
      const types = ["image/jpeg", "image/png"];
      if (types.indexOf(ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };

    $scope.webPreviewUploader.onSuccessItem = (fileItem, response, status, headers) => {
      template.preview = response.preview.preview;
      $scope.webPreviewUploader.clearQueue();
    };

    $scope.webPreviewUploader.onErrorItem = (fileItem, response, status, headers) => {
      console.error({fileItem, response, status, headers});
    };


    $scope.mobilePreviewUploader = new FileUploader({
      url: Restangular.configuration.baseUrl + ("/lms_pages/" + template.id),
      autoUpload: false,
      method: "PUT",
      alias: "mobile_preview",
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.mobilePreviewUploader.onAfterAddingFile = (item) => {
      const ref = item.file.type;
      const types = ["image/jpeg", "image/png"];
      if (types.indexOf(ref) < 0) {
        alert("The file must be png or jpg");
        return false;
      }
    };

    $scope.mobilePreviewUploader.onSuccessItem = (fileItem, response, status, headers) => {
      template.mobile_preview = response.mobile_preview;
      $scope.mobilePreviewUploader.clearQueue();
    };

    $scope.mobilePreviewUploader.onErrorItem = (fileItem, response, status, headers) => {
      console.error({fileItem, response, status, headers});
    };

    $scope.cancel = () => {
      $modalInstance.dismiss("cancel");
    };

    $scope.close = () => {
      $modalInstance.dismiss("close");
    };

    $scope.saving = false;
    $scope.saveTemplate = (lesson, editTemplateLesson) => {
      if (editTemplateLesson.$invalid) {
        return false;
      }
      $scope.saving = true;
      lesson = angular.copy(lesson);
      lesson.is_template = true;
      lesson.tags = _.map(lesson.tags, (tag) => {
        return tag.text;
      });
      lesson.tags = lesson.tags.join(",");
      lesson.colors = _.map(lesson.colors, (tag) => {
        return tag.text;
      });

      Lesson.update(lesson).then((new_site) => {
        $scope.saving = false;
        $scope.webPreviewUploader.uploadAll();
        $scope.mobilePreviewUploader.uploadAll();
        $rootScope.$broadcast("lesson_form:updated");
        $scope.close();
      }, (errors) => {
        $scope.errors = errors.data.errors;
        $scope.saving = false;
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/lesson/editLesson.controller.js